import { pipe, camelCase, upperFirst } from 'lodash/fp';
/**
 * Converts given string to the PascalCase notation.
 *
 * @param {string} string - string to be transformed.
 *
 * @returns {string} transformed string
 *
 * @example
 * pascalCase('some-string)
 * // => SomeString
 */

export default pipe([camelCase, upperFirst]);